const signMap: Record<string, string> = { "1": "ONE", "X": "X", "2": "TWO" };
const signOrder = ["ONE", "X", "TWO"];

// Parses "1-X2--1X2" into [["ONE"], ["X", "TWO"], [], ["ONE", "X", "TWO"]]; undefined if invalid.
export const parseCouponSigns = (value: string | null | undefined, numFixtures: number): string[][] | undefined => {
    if (!value) {
        return undefined;
    }

    const legs = value.split("-");
    if (legs.length !== numFixtures) {
        return undefined;
    }

    const parsed: string[][] = [];
    for (const leg of legs) {
        const signs: string[] = [];
        for (const char of leg.toUpperCase().split("")) {
            const sign = signMap[char];
            if (!sign) {
                return undefined;
            }
            signs.push(sign);
        }
        parsed.push(signOrder.filter(sign => signs.indexOf(sign) > -1));
    }
    return parsed;
};
